import { NgModule, LOCALE_ID } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import localePT from '@angular/common/locales/pt';
import localeExtraPT from '@angular/common/locales/extra/pt';


import { TooltipModule } from 'primeng/tooltip';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { ToolbarModule } from 'primeng/toolbar';
import { FileUploadModule } from 'primeng/fileupload';
import { DialogModule } from 'primeng/dialog';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import {DropdownModule} from 'primeng/dropdown';
import {CheckboxModule} from 'primeng/checkbox';

import { SharedModule } from 'src/app/shared/shared.module';
import { CidadeListComponent } from './cidade-list/cidade-list.component';
import { ToastModule } from 'primeng/toast';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';

registerLocaleData(localePT, 'pt', localeExtraPT);

@NgModule({
  providers: [{provide: LOCALE_ID, useValue: 'pt'}],
  declarations: [CidadeListComponent],
  imports: [
  TooltipModule,
    CommonModule,
    FormsModule,
    TableModule,
    ButtonModule,
    RatingModule,
    InputTextModule,
    ToolbarModule,
    FileUploadModule,
    DialogModule,
    RouterModule,
    ConfirmDialogModule,
    RadioButtonModule,
    InputTextModule,
    InputNumberModule,
    DialogModule,
    BrowserModule,
    DropdownModule,
    CheckboxModule,
    SharedModule,
    ToastModule,
    PipesModule
  ],
  exports: [CidadeListComponent]
})
export class CidadeModule { }